import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: designTokens.spacing[4],
    overflowY: "auto",
  },
  modalContent: {
    backgroundColor: designTokens.neutral.white,
    padding: designTokens.spacing[5],
    ...shorthands.borderRadius(designTokens.borderRadius.xl),
    boxShadow: designTokens.shadow.xl,
    width: "100%",
    maxWidth: "500px",
    boxSizing: "border-box",
  },
  content: {
    display: "block !important" as "block",
    ...shorthands.padding("0"),
  },
  titleContainer: {
    color: designTokens.neutral[900],
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: designTokens.spacing[4],
  },
  loadingContainer: {
    paddingTop: designTokens.spacing[4],
  },
  fileSpinner: {
    flexShrink: 0,
  },
  fileItemDisabled: {
    opacity: 0.5,
    pointerEvents: "none" as const,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[5],
    paddingTop: designTokens.spacing[4],
    width: "100%",
  },
  uploadingIndicator: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[3],
    backgroundColor: designTokens.accent[50],
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    marginTop: designTokens.spacing[3],
    color: designTokens.neutral[900],
  },
  body: {
    color: designTokens.neutral[900],
    display: "block !important" as "block",
  },
  documentList: {
    marginTop: designTokens.spacing[6],
  },
});
